// extracted by mini-css-extract-plugin
export default {"Loading":"_Loading--juIgC","CreatingFromTemplate":"_CreatingFromTemplate--HmRFX"};